import React, { useState, useEffect } from "react";
import cx from "classnames";
import PropTypes from "prop-types";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";

import styles from "assets/jss/material-dashboard-pro-react/components/tableStyle";

const useStyles = makeStyles(styles);

export default function CustomTable(props) {
  const classes = useStyles();
  const {
    tableHead,
    tableCols,
    tableData,
    tableHeaderColor,
    hover,
    select,
    selected,
    colorsColls,
    coloredColls,
    customCellClasses,
    customClassesForCells,
    striped,
    onRowClick,
    customHeadCellClasses,
    customHeadClassesForCells
  } = props;
  const [selectedIndex, setSelectedIndex] = useState(selected);
  
  useEffect(() => {
    setSelectedIndex(selected);
}, [selected]);

  return (
    <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        {tableHead !== undefined ? (
          <TableHead className={classes[tableHeaderColor]}>
            <TableRow className={classes.tableRow + " " + classes.tableRowHead + " " + classes.tableHeadFontSize}>
              {tableHead.map((prop, key) => {
                const tableCellClasses =
                  classes.tableHeadCell +
                  " " +
                  classes.tableCell +
                  " " +
                  cx({
                    [customHeadCellClasses[
                      customHeadClassesForCells.indexOf(key)
                    ]]: customHeadClassesForCells.indexOf(key) !== -1
                  });
                return (
                  <TableCell className={tableCellClasses} key={key}>
                    {prop}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {tableData.length === 0 ? (
            <TableRow><TableCell className={classes.tableCell} colSpan={tableHead.length}>데이터가 없습니다</TableCell></TableRow>
          ) : null}
          {tableData.map((prop, rowIndex) => {
            var rowColor = "";
            var rowColored = false;
            if (prop.color !== undefined) {
              rowColor = prop.color;
              rowColored = true;
            }
            if (select && rowIndex === selectedIndex){
              rowColor = select;
              rowColored = true;
            }
            const tableRowClasses = cx({
              [classes.tableRowBody]: true,
              [classes.tableRowHover]: hover,
              [classes[rowColor + "Row"]]: rowColored,
              [classes.tableStripedRow]: striped && rowIndex % 2 === 0
            });
            return (
              <TableRow
                key={rowIndex}
                hover={hover}
                className={classes.tableRow + " " + tableRowClasses}
              >
                {(tableCols ? tableCols : prop).map((key) => {
                  const data = tableCols ? prop[key] : key;
                  const tableCellClasses =
                    classes.tableCell +
                    " " +
                    cx({
                      [classes[colorsColls[coloredColls.indexOf(key)]]]:
                        coloredColls.indexOf(key) !== -1,
                      [customCellClasses[customClassesForCells.indexOf(key)]]:
                        customClassesForCells.indexOf(key) !== -1
                    });
                  return (
                    <TableCell className={tableCellClasses} key={key} onClick={(e) => { if (onRowClick) onRowClick(prop, e); setSelectedIndex(rowIndex);}}>
                      {data}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

CustomTable.defaultProps = {
  tableHeaderColor: "gray",
  hover: false,
  colorsColls: [],
  coloredColls: [],
  striped: false,
  customCellClasses: [],
  customClassesForCells: [],
  customHeadCellClasses: [],
  customHeadClassesForCells: []
};

const colors = [
  "warning",
  "primary",
  "danger",
  "success",
  "info",
  "rose",
  "gray"
];
CustomTable.propTypes = {
  tableHeaderColor: PropTypes.oneOf(colors),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  // Of(PropTypes.arrayOf(PropTypes.node)) || Of(PropTypes.object),
  tableData: PropTypes.array,
  hover: PropTypes.bool,
  select: PropTypes.oneOf(colors),
  selected: PropTypes.number,
  coloredColls: PropTypes.arrayOf(PropTypes.number),
  // Of(["warning","primary","danger","success","info","rose","gray"]) - colorsColls
  colorsColls: PropTypes.array,
  customCellClasses: PropTypes.arrayOf(PropTypes.string),
  customClassesForCells: PropTypes.arrayOf(PropTypes.number),
  customHeadCellClasses: PropTypes.arrayOf(PropTypes.string),
  customHeadClassesForCells: PropTypes.arrayOf(PropTypes.number),
  striped: PropTypes.bool,
  onRowClick: PropTypes.func,
  tableCols: PropTypes.arrayOf(PropTypes.string)
};
